import { useCallback as e } from "react";
import { getFormDataFromEvent as t } from "../../../../helpers/utils.js";
import { useAuthenticator as r } from "../useAuthenticator/index.js";

function a() {
  var _r = r(function (e) {
    return [e.submitForm, e.updateBlur, e.updateForm];
  }),
      a = _r.submitForm,
      u = _r.updateBlur,
      m = _r.updateForm;

  return {
    handleBlur: e(function (_ref) {
      var e = _ref.target.name;
      u({
        name: e
      });
    }, [u]),
    handleChange: e(function (_ref2) {
      var _ref2$target = _ref2.target,
          e = _ref2$target.checked,
          t = _ref2$target.name,
          r = _ref2$target.type,
          a = _ref2$target.value;
      m({
        name: t,
        value: "checkbox" === r && !e ? void 0 : a
      });
    }, [m]),
    handleSubmit: e(function (e) {
      e.preventDefault(), a(t(e));
    }, [a])
  };
}

export { a as useFormHandlers };